import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useCurrentOrganizationId } from '@cast/infrastructure-organization';
import { overrideOrganizationHeader } from '@cast/api-client';

export const RBAC_RESOURCES_QUERY_KEY = 'rbac-resources';
const getRbacResourcesKey = (params: { organizationId: string | undefined }) =>
  [RBAC_RESOURCES_QUERY_KEY, params.organizationId] as const;

const getRbacResourcesQueryOptions = ({
  organizationId,
  enabled = true,
}: {
  organizationId: string | undefined;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getRbacResourcesKey({ organizationId }),
    queryFn: async () => {
      const { data } = await apiClient.rbac.getResources(
        {
          organizationId: organizationId!,
        },
        {
          headers: overrideOrganizationHeader(organizationId),
        }
      );
      return data.resources ?? [];
    },
    enabled: !!organizationId && enabled,
  });

type UseRbacResourcesQueryOptions = {
  organizationId?: string;
  enabled?: boolean;
};

export const useRbacResourcesQuery = (
  options?: UseRbacResourcesQueryOptions
) => {
  const currentOrganizationId = useCurrentOrganizationId();
  const organizationId = options?.organizationId ?? currentOrganizationId;

  return useQuery(
    getRbacResourcesQueryOptions({
      organizationId,
      enabled: options?.enabled,
    })
  );
};
